export default __webpack_public_path__ + "static/media/arrow.3028b57c.svg";